import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserRole } from "../../../constant/userRole";
import AuthContext from "../../../context/authProvider";
import useAuth from "../../../hooks/useAuth";
import logo from "../../../img/logo/Honey bee time tracker logo.svg";
import { NameProccess, userRoleTextRender } from "../../globle-component/globle";
import { getAccountData } from "../../../services/account";

function SideBar() {
  let orgName = localStorage.getItem("organizationName");
  let authUserRole = localStorage.getItem("orgUserRole");

  const [timeZoneStatus, setTimeZoneStatus] = useState(false);
  const [timerCount, setTimerCount] = useState(null)

  const checkTimeZone = () => {
    let timezoneRedirectStatus = false;
    try {
      getAccountData().then(({ data }) => {
        if (data.timezone == null || data.timezone == "") {
          timezoneRedirectStatus = true;
        } else {
          timezoneRedirectStatus = false;
        }

        if (timezoneRedirectStatus == true) {
          setTimeZoneStatus(true)
          setTimerCount(5)
          // window.location.replace("/account");
        }
      });


    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    checkTimeZone()
  }, []);

  const { userRole } = useAuth(AuthContext);

  if (orgName.length >= 10) {
    // orgName = orgName.substring(0, 10) + ' ...';
    orgName = NameProccess(orgName, 10);
  }

  var pathArray = document.location.href.split("/");
  var routePath = pathArray[3];

  useEffect(() => {
    if (timerCount != null) {
      setTimeout(() => {
        if (timerCount > 0) {
          setTimerCount(timerCount - 1)
        } else {
          window.location.replace("/account");
        }
      }, 1000);
    }

  }, [timerCount])

  return (
    <>
      <div className="flex flex-col sidebar  h-auto overflow top-0 left-0 absolute sidebar text-white sticky top-0 left-0 fixed z-10">
        <div className="bg-[#1d212c] w-[269px] h-[60px] ">
          <img
            src={logo}
            alt="logo"
            className=" w-[143px] h-[21.5px] my-[19px] ml-[40px] mr-[86px]"
          />
        </div>

        <div className="flex flex-wrap w-60 py-1 mx-auto my-2 org-title">
          <div className="grid grid-cols-3 gap-4 w-full m-7">
            <div className="col-span-2 ...">
              <h3 className="font-semibold my-auto capitalize">
                {orgName}
              </h3>
              <span className="font-normal py-1  my-auto capitalize">
                {" "}
                {authUserRole !== 'null' ? (<>{userRoleTextRender(Number(authUserRole))}</>) : null}
              </span>
            </div>
            <div>
              <button className={"border-2 rounded-full w-12 h-12"}>
                <p className="font-bold">{orgName[0].toUpperCase()}</p>
              </button>
            </div>
          </div>
        </div>
        <hr className="mx-auto bg-gray-800 w-[193px] border-0 h-px dark:bg-gray-700 mb-2 hover:bg-blue-500"></hr>
        <Link to={"/"}>
          <button
            className={`flex flex-row w-full py-1 ${routePath == ""
              ? "text-yellow-300 border-l-4 border-yellow-300 "
              : " hover:text-amber-300 "
              }`}
          >
            <div
              className={`w-9 h-9 mx-6  ${routePath == "" ? "menu-active-container rounded-lg" : null
                }`}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
                className="mx-auto my-2.5"
              >
                <path d="M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H5.27273C6.10115 0.5 6.77273 1.17157 6.77273 2V6.77273H2C1.17157 6.77273 0.5 6.10115 0.5 5.27273V2Z" />
                <path d="M0.5 14C0.5 14.8284 1.17157 15.5 2 15.5H5.27273C6.10115 15.5 6.77273 14.8284 6.77273 14V9.22727H2C1.17157 9.22727 0.5 9.89885 0.5 10.7273V14Z" />
                <path d="M15.5 2C15.5 1.17157 14.8284 0.5 14 0.5H10.7273C9.89885 0.5 9.22727 1.17157 9.22727 2V6.77273H14C14.8284 6.77273 15.5 6.10115 15.5 5.27273V2Z" />
                <path d="M15.5 14C15.5 14.8284 14.8284 15.5 14 15.5H10.7273C9.89885 15.5 9.22727 14.8284 9.22727 14V9.22727H14C14.8284 9.22727 15.5 9.89885 15.5 10.7273V14Z" />
              </svg>
            </div>
            <h2 className=" font-medium my-auto">Dashboard</h2>
          </button>
        </Link>
        <Link to={"/WorkTimes"}>
          <button
            className={`flex flex-row w-full py-1 ${routePath == "WorkTimes"
              ? "text-yellow-300 border-l-4 border-yellow-300"
              : " hover:text-yellow-300"
              }`}
          >
            <div
              className={`w-10 h-10 mx-6 ${routePath == "WorkTimes"
                ? "menu-active-container rounded-lg"
                : null
                }`}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto my-2.5"
              >
                <g clipPath="url(#clip0_15_74)">
                  <path
                    d="M9.26199 3.36043C9.46202 3.00934 9.65428 2.67196 9.86469 2.30293C9.64261 2.24909 9.44063 2.19102 9.23508 2.15251C5.64901 1.48265 2.24353 3.79047 1.50012 7.39105C0.732393 11.1107 3.34875 14.8089 7.08785 15.2901C7.17538 15.3015 7.26292 15.313 7.35046 15.3234C7.74891 15.3714 8.02189 15.698 7.98461 16.0827C7.947 16.47 7.62117 16.7411 7.21883 16.7026C5.65193 16.5535 4.23806 15.9972 3.02163 14.9958C0.842949 13.2019 -0.167933 10.8683 0.0227016 8.04428C0.270397 4.36996 3.18827 1.25033 6.79963 0.735124C8.02384 0.560234 9.22632 0.644416 10.4042 1.02291C10.5452 1.06794 10.6029 1.03205 10.6668 0.914256C10.8299 0.614398 11.0043 0.321393 11.1884 0C11.8388 1.1345 12.4707 2.23637 13.1149 3.36043H9.26199Z"
                    fill="currentColor"
                  />
                  <path
                    d="M11.5084 11.4468C11.3739 11.6439 11.1966 11.6664 10.9923 11.5078C10.4531 11.0895 9.91593 10.6693 9.37807 10.25C9.14399 10.0676 8.90667 9.88812 8.67681 9.70083C8.59478 9.63427 8.53448 9.61828 8.42879 9.66853C7.89157 9.92238 7.26812 9.70247 7.00973 9.17975C6.74452 8.64432 6.9478 8.00708 7.48437 7.73561C7.60919 7.67231 7.63642 7.59955 7.6361 7.47295C7.63188 6.36292 7.6335 5.25289 7.6335 4.14287C7.6335 4.06032 7.63091 3.97776 7.63642 3.89554C7.65036 3.69031 7.78588 3.56469 7.98073 3.57121C8.16845 3.57708 8.29781 3.69977 8.30267 3.89782C8.3098 4.183 8.30526 4.4685 8.30559 4.754V5.74363C8.30559 6.32703 8.30818 6.91076 8.30332 7.49416C8.30234 7.60868 8.33087 7.67068 8.44111 7.72549C8.90375 7.95651 9.12486 8.42538 9.01398 8.92949C8.98869 9.045 9.01171 9.1096 9.10476 9.18106C9.87508 9.77555 10.6415 10.3743 11.4079 10.9734C11.5982 11.1218 11.6277 11.2729 11.5084 11.4471V11.4468Z"
                    fill="currentColor"
                  />
                  <path
                    d="M16 8.84172C15.988 9.4659 15.9092 10.0796 15.7458 10.6816C15.6402 11.0699 15.2994 11.2732 14.9191 11.175C14.532 11.0755 14.3102 10.7192 14.413 10.3335C14.592 9.65972 14.6484 8.97582 14.6088 8.28115C14.5858 7.87101 14.8332 7.57931 15.2122 7.55647C15.6019 7.53331 15.9349 7.81098 15.9679 8.19665C15.9864 8.41102 15.9896 8.62637 15.9997 8.84172H16Z"
                    fill="currentColor"
                  />
                  <path
                    d="M14.8627 6.86572C14.553 6.86409 14.3235 6.70323 14.2207 6.40044C14.0045 5.76451 13.691 5.18274 13.2805 4.65219C13.0396 4.34026 13.0727 3.97678 13.357 3.74022C13.6543 3.4929 14.1021 3.5128 14.3456 3.80581C14.7768 4.32526 15.112 4.90539 15.3678 5.53121C15.4252 5.67184 15.4787 5.81443 15.526 5.95865C15.68 6.43111 15.359 6.86801 14.8627 6.86572Z"
                    fill="currentColor"
                  />
                  <path
                    d="M11.5321 15.9261C10.8619 16.2895 10.15 16.531 9.39844 16.653C9.31156 16.6667 9.22402 16.6782 9.16923 16.6863C8.80644 16.6837 8.53637 16.4145 8.50006 16.0527C8.4644 15.6973 8.6881 15.3662 9.03079 15.3104C9.56736 15.2229 10.089 15.0898 10.5857 14.8653C10.695 14.816 10.8029 14.7645 10.9093 14.7097C11.2967 14.5103 11.6481 14.6 11.8287 14.9465C12.0151 15.3042 11.889 15.7332 11.5324 15.9267L11.5321 15.9261Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.0222 12.4165C14.982 12.5346 14.9567 12.6603 14.8996 12.7692C14.5498 13.4358 14.1001 14.0264 13.5448 14.5341C13.2261 14.8255 12.8526 14.8196 12.5767 14.5233C12.3303 14.2587 12.2778 13.7879 12.6227 13.4946C13.0883 13.0991 13.4469 12.6087 13.7386 12.0703C13.9192 11.7375 14.1429 11.6161 14.4344 11.6889C14.7648 11.7711 14.9956 12.0654 15.0219 12.4168L15.0222 12.4165Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_74">
                    <rect width="16" height="16.7059" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2 className=" font-medium my-auto">Work-Time</h2>
          </button>
        </Link>
        <Link to={"/Activities"}>
          <button
            className={`flex flex-row w-full py-1 ${routePath == "Activities"
              ? "text-yellow-300 border-l-4 border-yellow-300"
              : " hover:text-yellow-300"
              }`}
          >
            <div
              className={`w-10 h-10 mx-6 ${routePath == "Activities"
                ? "menu-active-container rounded-lg"
                : null
                }`}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto my-3"
              >
                <path
                  d="M15.9959 5.43253C15.9941 4.76234 15.9131 4.09924 15.7465 3.44916C15.3668 1.96682 14.5025 0.918052 13.0495 0.400473C12.3248 0.141979 11.572 0.0195342 10.8079 0.012436C9.09154 -0.00471805 7.37572 0.00238013 5.65932 1.40482e-05C4.8595 -0.00116899 4.0679 0.0721794 3.29567 0.291633C1.89086 0.689726 0.90385 1.55098 0.405652 2.94992C0.143937 3.68518 0.018948 4.44942 0.0119064 5.22491C-0.00511098 7.05447 -0.000416538 8.88345 0.00486471 10.713C0.00721193 11.4187 0.096993 12.1155 0.285944 12.7969C0.648003 14.1024 1.40322 15.0725 2.6584 15.6108C3.46701 15.9574 4.32199 16.0958 5.19163 16.1148C6.12759 16.1361 7.06472 16.1195 8.00126 16.1195V16.1296C8.72831 16.1296 9.45536 16.1284 10.1824 16.1296C10.9869 16.1313 11.7856 16.0757 12.5689 15.8728C13.9209 15.5227 14.9361 14.759 15.4906 13.4387C15.8339 12.623 15.9777 11.7612 15.9871 10.884C16.0064 9.06682 15.9994 7.24908 15.9953 5.43134L15.9959 5.43253ZM14.8651 10.8568C14.8551 11.4246 14.7548 12.0019 14.6128 12.5538C14.3012 13.7653 13.4867 14.4845 12.2926 14.7844C11.6506 14.9459 10.9981 15.0027 10.3385 15.0027C8.6397 15.0004 6.9409 15.0057 5.2421 14.9915C4.58898 14.9862 3.94467 14.8826 3.32383 14.6661C2.29047 14.3059 1.66024 13.5701 1.36919 12.5219C1.19314 11.8907 1.12273 11.2454 1.11921 10.5929C1.1151 9.74825 1.11803 8.90416 1.11803 8.06006H1.1239C1.1239 7.12782 1.11334 6.195 1.12742 5.26276C1.13681 4.65764 1.22718 4.06079 1.40674 3.47992C1.74768 2.37496 2.48412 1.68821 3.58203 1.37944C4.25979 1.18956 4.9528 1.12508 5.65345 1.12627C7.35812 1.12863 9.06279 1.1239 10.7675 1.13751C11.3554 1.14224 11.9358 1.23452 12.5032 1.40487C13.6252 1.74204 14.3229 2.48735 14.6345 3.61538C14.8006 4.21814 14.8786 4.83332 14.8798 5.45737C14.8839 7.25737 14.8986 9.05795 14.8657 10.8579L14.8651 10.8568Z"
                  fill="currentColor"
                />
                <path
                  d="M11.9182 6.5369C11.6413 6.906 11.3572 7.26979 11.0762 7.63594C10.7916 8.00682 10.5075 8.3777 10.2218 8.7474C9.95536 9.09344 9.60328 9.26972 9.2107 9.27918C8.84923 9.278 8.56874 9.16797 8.31876 8.96863C7.90448 8.63738 7.48843 8.3079 7.07239 7.97961C6.89224 7.83765 6.82299 7.84711 6.68392 8.02871C6.11942 8.76574 5.55667 9.50455 4.99099 10.241C4.82023 10.4634 4.59314 10.5427 4.3637 10.4711C3.98051 10.3522 3.84203 9.91211 4.09259 9.57671C4.45641 9.09049 4.82903 8.61076 5.19755 8.12808C5.41056 7.85007 5.62122 7.56969 5.83658 7.29345C6.31247 6.683 7.09469 6.57949 7.7079 7.05211C8.13744 7.38277 8.55818 7.72467 8.9842 8.06065C9.15613 8.1967 9.23946 8.18664 9.37442 8.01155C9.92015 7.3041 10.4653 6.59605 11.0093 5.88682C11.1143 5.75017 11.2416 5.65612 11.4136 5.63897C11.6489 5.61649 11.8384 5.70404 11.9581 5.91225C12.0808 6.12579 12.0661 6.34229 11.9188 6.53749L11.9182 6.5369Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="my-auto mr-20">
              <h2 className="font-medium">Activity</h2>
            </div>
          </button>
        </Link>
        <Link to="/Projects">
          <button
            className={`flex flex-row w-full py-1 ${routePath == "Projects"
              ? "text-yellow-300 border-l-4 border-yellow-300"
              : " hover:text-yellow-300"
              }`}
          >
            <div
              className={`w-10 h-10 mx-6 ${routePath == "Projects"
                ? "menu-active-container rounded-lg"
                : null
                }`}
            >
              <svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto my-2.5"
              >
                <path
                  d="M12.4734 9.64664C12.1716 9.38809 11.7573 9.43691 11.462 9.74609C10.8878 10.3488 10.3058 10.943 9.72431 11.5385C9.26492 12.0086 8.80974 12.4799 8.57103 13.1133C8.5548 13.1573 8.46701 13.1995 8.41169 13.1995C7.41415 13.2049 6.41721 13.2019 5.41967 13.2061C5.31565 13.2061 5.28137 13.1609 5.24109 13.0784C5.14127 12.8716 5.0589 12.6462 4.91519 12.4733C4.56885 12.0568 4.19785 11.6602 3.82445 11.2661C3.40174 10.8207 2.94536 10.406 2.5413 9.94498C1.82817 9.13135 1.45056 8.17066 1.41688 7.08401C1.37479 5.72374 1.77345 4.5051 2.63389 3.4522C3.37168 2.55058 4.29947 1.91294 5.4347 1.63148C5.92235 1.51034 6.43285 1.46875 6.93613 1.42355C7.44181 1.37895 7.77072 0.928744 7.60115 0.463468C7.51096 0.21516 7.31313 0.0843765 7.07743 0H6.51101C6.48275 0.00783496 6.45509 0.021094 6.42683 0.022902C5.49664 0.0813629 4.61515 0.322439 3.78476 0.744321C2.6826 1.30422 1.78848 2.10519 1.10962 3.1382C0.430167 4.17242 0.0669877 5.31391 0.00806127 6.55304C-0.0490613 7.75119 0.195664 8.87761 0.797555 9.92087C1.27017 10.7399 1.92197 11.4053 2.59661 12.0538C2.94536 12.3889 3.2869 12.7336 3.614 13.0898C3.87315 13.3719 4.00965 13.7076 4.00063 14.1059C3.9862 14.7327 3.99522 15.3601 3.99762 15.9869C4.00183 17.2447 4.92421 18.1675 6.1803 18.1717C6.66975 18.1735 7.15981 18.1729 7.64926 18.1717C8.91557 18.1681 9.83555 17.246 9.83915 15.9761C9.84096 15.3487 9.84456 14.7219 9.83795 14.0951C9.83434 13.7678 9.91191 13.4665 10.1254 13.223C10.4284 12.8771 10.7525 12.5504 11.0694 12.2165C11.5606 11.6982 12.0639 11.1907 12.5407 10.6592C12.8264 10.3403 12.7795 9.90821 12.4746 9.64725L12.4734 9.64664ZM8.40508 16.1545C8.38583 16.4926 8.08218 16.7421 7.73825 16.7481C7.18987 16.7584 6.64149 16.759 6.09312 16.7481C5.72934 16.7409 5.4323 16.4594 5.42027 16.099C5.40404 15.6157 5.41667 15.1311 5.41667 14.6309H8.41349C8.41349 15.1438 8.43454 15.6506 8.40628 16.1557L8.40508 16.1545Z"
                  fill="currentColor"
                />
                <path
                  d="M15.6789 4.59189C15.5141 4.46713 15.3445 4.34961 15.1768 4.22847C14.9549 4.06755 14.9495 3.85299 15.1623 3.68906C15.3451 3.54863 15.5303 3.41182 15.7095 3.26718C16.0096 3.0249 16.0805 2.69342 15.9061 2.34808C15.8105 2.15823 15.7101 1.97079 15.6043 1.78637C15.4089 1.44585 15.086 1.3229 14.7138 1.44826C14.4739 1.52902 14.2382 1.62365 13.997 1.70019C13.9405 1.71827 13.8636 1.7032 13.8052 1.6797C13.4511 1.54047 13.2532 1.28915 13.2659 0.893788C13.2671 0.859435 13.2472 0.825082 13.2448 0.790126C13.2178 0.406815 13.0386 0.135605 12.6718 0H11.6803C11.352 0.128976 11.1529 0.357997 11.1193 0.720214C11.1018 0.908253 11.0694 1.09509 11.0447 1.28252C11.0255 1.42958 10.4999 1.78938 10.3562 1.75262C10.322 1.74358 10.2883 1.73273 10.2546 1.72188C10.0406 1.65559 9.8289 1.58266 9.61304 1.5248C9.25827 1.42958 8.95342 1.56097 8.77664 1.88461C8.67202 2.07566 8.57581 2.27274 8.48201 2.46982C8.29922 2.85193 8.38701 3.18823 8.73155 3.43292C8.89991 3.55285 9.07248 3.66676 9.24264 3.78368C9.41521 3.90302 9.42303 4.18568 9.25707 4.31947C9.07729 4.46352 8.8945 4.60334 8.71651 4.7504C8.40565 5.00594 8.3377 5.35007 8.53192 5.69963C8.63173 5.88044 8.73816 6.05763 8.8482 6.23241C9.04963 6.55123 9.3611 6.66273 9.71946 6.5434C9.93713 6.47047 10.1518 6.3867 10.3701 6.31498C10.42 6.2981 10.4897 6.29027 10.5324 6.31257C10.6839 6.39032 10.8306 6.47951 10.9726 6.57414C11.0092 6.59885 11.0339 6.6567 11.0429 6.70432C11.0934 6.95323 11.1313 7.20455 11.1848 7.45286C11.257 7.78916 11.5221 8.00914 11.8631 8.01999C12.0813 8.02662 12.2996 8.02601 12.5179 8.01999C12.8666 8.01095 13.136 7.78434 13.2039 7.44201C13.2466 7.22745 13.2815 7.01109 13.3092 6.79472C13.3254 6.66755 13.3675 6.58197 13.4932 6.52351C13.6363 6.45661 13.7601 6.34933 13.9002 6.27641C13.964 6.24326 14.0542 6.22458 14.1227 6.24145C14.3464 6.29388 14.5641 6.36862 14.7859 6.42889C15.1605 6.53014 15.4642 6.39815 15.6476 6.05522C15.739 5.88285 15.8268 5.70928 15.9103 5.53329C16.0841 5.16565 16.0041 4.83779 15.6795 4.59249L15.6789 4.59189ZM13.6062 4.04525C13.5755 4.84803 12.9279 5.45856 12.1373 5.42842C11.3658 5.39949 10.7495 4.73654 10.7795 3.96871C10.8108 3.17195 11.468 2.56022 12.2581 2.59397C13.0217 2.62652 13.6345 3.28647 13.6062 4.04465V4.04525Z"
                  fill="currentColor"
                />
                <path
                  d="M6.11115 4.28633C5.67101 4.45568 5.26393 4.67024 4.93743 5.0198C4.45099 5.54052 4.22972 6.16431 4.20506 6.87005C4.19304 7.20816 3.98319 7.45406 3.66811 7.53603C3.3837 7.60955 3.0584 7.49745 2.9165 7.2383C2.83232 7.08461 2.80586 6.89898 2.75415 6.72722C2.84254 5.00111 3.99642 3.46908 5.62351 2.9592C6.01615 2.83626 6.40278 3.01405 6.53566 3.37868C6.67035 3.74752 6.49898 4.13746 6.11175 4.28633H6.11115Z"
                  fill="currentColor"
                />
                <path
                  d="M5.48219 9.11688C5.48459 9.50682 5.16471 9.82986 4.77567 9.83047C4.38664 9.83047 4.06615 9.50803 4.06856 9.11809C4.07096 8.73478 4.38423 8.41837 4.76605 8.41354C5.15509 8.40872 5.47978 8.72694 5.48219 9.11749V9.11688Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h2 className=" font-medium my-auto">Project</h2>
          </button>
        </Link>
        
        <Link to={"/task"}>
          <button
            className={`flex flex-row w-full py-1 ${routePath == "task"
              ? "text-yellow-300 border-l-4 border-yellow-300"
              : " hover:text-yellow-300"
              }`}
          >
            <div
              className={`w-10 h-10 mx-6 ${routePath == "task" ? "menu-active-container rounded-lg" : null
                }`}
            >
              <svg
                width="16"
                height="22"
                viewBox="0 0 16 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto my-2"
              >
                <path
                  d="M15.9947 4.85088C15.9947 3.93313 15.3703 3.09209 14.5163 2.85484C14.2956 2.79304 14.0592 2.77173 13.8296 2.76676C13.2683 2.75468 12.7062 2.76321 12.1223 2.76321C12.1223 2.49044 12.125 2.23898 12.1223 1.98681C12.1189 1.73606 12.0243 1.60465 11.7892 1.54427C11.6878 1.51799 11.5788 1.51373 11.4739 1.51302C11.0833 1.50946 10.6919 1.50591 10.3006 1.51444C10.1738 1.51728 10.1162 1.4704 10.0682 1.35177C9.80161 0.703943 9.33075 0.291948 8.68033 0.0987366C8.54736 0.0589578 8.41166 0.0326754 8.27664 0H7.60086C7.5707 0.0120757 7.54191 0.0305444 7.51107 0.0369374C6.74756 0.191791 6.20063 0.63433 5.87781 1.36669C5.82778 1.47892 5.77021 1.51657 5.65438 1.51444C5.22328 1.51017 4.79286 1.50591 4.36244 1.5187C4.00879 1.52864 3.87514 1.68492 3.87377 2.04577C3.87377 2.27805 3.87377 2.50962 3.87377 2.75468C3.79015 2.75823 3.72572 2.76392 3.6613 2.76392C3.15069 2.76392 2.64008 2.76392 2.13016 2.76392C0.88757 2.76818 0.000690106 3.68877 4.72714e-06 4.97164V12.7832C4.72714e-06 14.8986 0.00206086 17.0147 4.72714e-06 19.1308C-0.00136603 19.8375 0.295403 20.3689 0.858099 20.7503C1.24123 21.0096 1.66685 21.1112 2.12194 21.1112C6.03956 21.1091 9.95719 21.1112 13.8748 21.1076C14.04 21.1076 14.2059 21.0934 14.369 21.0671C15.3059 20.9144 15.9967 20.1203 15.9974 19.1762C16.0009 14.4021 16.0009 9.62718 15.9974 4.8523L15.9947 4.85088ZM4.8566 2.51459H6.04299C6.38773 2.51317 6.55291 2.38318 6.64544 2.03937C6.81404 1.41641 7.29449 0.985236 7.87021 0.941195C8.50418 0.892182 9.08676 1.33046 9.26564 1.99036C9.37736 2.40094 9.51992 2.51317 9.93114 2.51388H11.1333V4.51205H4.8566V2.51388V2.51459ZM15.0324 5.02136V19.015C15.0324 19.6479 14.7261 20.0087 14.1168 20.0883C14.0187 20.1011 13.9187 20.1053 13.82 20.1053C9.93526 20.1053 6.0519 20.1068 2.16717 20.1025C1.98418 20.1025 1.79364 20.0819 1.61955 20.0265C1.17954 19.8873 0.963647 19.5648 0.963647 19.0874C0.963647 14.368 0.963647 9.6492 0.963647 4.92973C0.963647 4.31529 1.36665 3.81948 1.94237 3.78609C2.53728 3.75199 3.13493 3.77259 3.73121 3.76975C3.77027 3.76975 3.80865 3.77828 3.87308 3.78609V4.85444C3.87308 5.34528 4.04648 5.52641 4.51802 5.52641C6.83117 5.52641 9.14433 5.52641 11.4582 5.52641C11.9366 5.52641 12.1216 5.33604 12.1223 4.8452C12.1237 4.50921 12.125 4.17251 12.1271 3.83581C12.1271 3.82303 12.136 3.81095 12.1456 3.78538C12.8049 3.78538 13.4547 3.75839 14.1003 3.7939C14.6171 3.82303 15.0112 4.31174 15.0317 4.85586C15.0338 4.91055 15.0317 4.96596 15.0317 5.02065L15.0324 5.02136Z"
                  fill="currentColor"
                />
                <path
                  d="M13.184 9.28196C13.0997 9.29829 13.012 9.299 12.927 9.299C11.1786 9.30043 9.43016 9.299 7.68245 9.299C7.61596 9.299 7.54948 9.30043 7.48437 9.29261C7.21022 9.26207 7.03202 9.06033 7.03545 8.78756C7.03888 8.51906 7.22736 8.31235 7.49945 8.2953C7.6708 8.28464 7.84351 8.29175 8.01623 8.29175H10.3013C11.208 8.29175 12.1155 8.29175 13.0222 8.29175C13.3012 8.29175 13.4938 8.42813 13.5575 8.6597C13.6329 8.93886 13.4629 9.22868 13.1854 9.28125L13.184 9.28196Z"
                  fill="currentColor"
                />
                <path
                  d="M13.1839 17.323C13.1003 17.34 13.0126 17.3428 12.9269 17.3428C12.0455 17.3443 11.1648 17.3428 10.2841 17.3428C9.40338 17.3428 8.49594 17.345 7.60221 17.3414C7.26706 17.34 7.06076 17.1702 7.03677 16.8904C7.01415 16.6226 7.16562 16.4038 7.41853 16.3462C7.46993 16.3349 7.52407 16.332 7.57685 16.332C9.39105 16.3306 11.2059 16.3299 13.0208 16.332C13.3416 16.332 13.5534 16.5196 13.5698 16.8023C13.5842 17.0608 13.4293 17.2739 13.1839 17.3223V17.323Z"
                  fill="currentColor"
                />
                <path
                  d="M13.0448 13.3167C12.3101 13.3202 11.5747 13.3181 10.8399 13.3181H10.2841C9.37665 13.3181 8.46921 13.3195 7.56245 13.3181C7.23964 13.3167 7.03128 13.1114 7.03471 12.8095C7.03814 12.5523 7.21291 12.3527 7.45965 12.3243C7.49871 12.3201 7.53915 12.3179 7.5789 12.3179C9.3931 12.3179 11.208 12.3179 13.0222 12.3179C13.3347 12.3179 13.5335 12.4785 13.5671 12.7434C13.6095 13.0673 13.3882 13.316 13.0455 13.3174L13.0448 13.3167Z"
                  fill="currentColor"
                />
                <path
                  d="M6.11432 11.9507C5.57012 12.4927 5.02114 13.029 4.47352 13.5674C4.38716 13.6519 4.30354 13.7415 4.2117 13.8196C4.00335 13.9972 3.7573 13.9943 3.56676 13.799C3.22819 13.4509 2.89441 13.0979 2.56885 12.7377C2.37283 12.5218 2.38243 12.2014 2.57091 12.0132C2.7635 11.8207 3.04245 11.8406 3.26451 12.0558C3.48178 12.2675 3.70315 12.4728 3.94235 12.7001C4.40087 12.2462 4.88132 11.766 5.36931 11.2943C5.45772 11.2084 5.57012 11.1295 5.68458 11.0962C5.89568 11.0344 6.11294 11.1537 6.21986 11.354C6.32815 11.5593 6.29868 11.7681 6.115 11.9507H6.11432Z"
                  fill="currentColor"
                />
                <path
                  d="M6.1205 7.92309C5.49544 8.54605 4.86626 9.16405 4.23228 9.77778C4.01091 9.9923 3.76074 9.98022 3.54622 9.75647C3.2282 9.42616 2.91293 9.09301 2.60245 8.7556C2.37628 8.51054 2.37011 8.18591 2.57709 7.98631C2.77448 7.79736 3.06577 7.83501 3.29948 8.07297C3.50167 8.27826 3.71071 8.47644 3.92935 8.69025C4.35223 8.27257 4.79224 7.83856 5.23225 7.40526C5.30422 7.33422 5.37344 7.26035 5.44883 7.19286C5.66952 6.99823 5.94779 7.01315 6.14312 7.22625C6.33228 7.43296 6.3316 7.71212 6.1205 7.92309Z"
                  fill="currentColor"
                />
                <path
                  d="M6.1355 15.9463C5.50358 16.5821 4.86412 17.2086 4.22055 17.8301C4.00877 18.0354 3.75655 18.0162 3.54888 17.7996C3.23155 17.4693 2.91628 17.1361 2.60511 16.7994C2.37825 16.5537 2.37003 16.2298 2.57496 16.0287C2.77098 15.8376 3.06432 15.8746 3.29803 16.1104C3.5009 16.3157 3.71063 16.5139 3.93201 16.7298C4.41657 16.2511 4.91004 15.7631 5.40489 15.2779C5.60639 15.0797 5.81132 15.0442 6.01761 15.165C6.31027 15.3361 6.37744 15.7034 6.13687 15.9456L6.1355 15.9463Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="my-auto mr-20">
              <h2 className="font-medium">Tasks</h2>
            </div>
          </button>
        </Link>

        {userRole == 2 ? (
          <Link to="/reports">
            <button
              className={`flex flex-row w-full py-1 ${
                routePath == "reports"
                  ? "text-yellow-300 border-l-4 border-yellow-300"
                  : " hover:text-yellow-300"
              }`}
            >
              <div
                  className={`w-10 h-10 mx-6 ${
                    routePath == "reports"
                      ? "menu-active-container rounded-lg"
                      : null
                  }`}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    strokeWidth={1.5} 
                    stroke="currentColor" 
                    className="mx-auto my-2 w-6 h-6"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" 
                    />
                  </svg>
              </div>
              <h2 className=" font-medium my-auto">Reports</h2>
            </button>
          </Link>
        ) : null}

        <Link to="/members">
          <button
            className={`flex flex-row w-full py-1 ${routePath == "members"
              ? "text-yellow-300 border-l-4 border-yellow-300"
              : " hover:text-yellow-300"
              }`}
          >
            <div
              className={`w-10 h-10 mx-6 ${routePath == "members"
                ? "menu-active-container rounded-lg"
                : null
                }`}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto my-2.5"
              >
                <path
                  d="M8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM8 12C10.7 12 13.8 13.29 14 14H2C2.23 13.28 5.31 12 8 12ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h2 className=" font-medium my-auto">Members</h2>
          </button>
        </Link>

        {userRole == 1 ? (
          <Link to="/settings">
            <button
              className={`flex flex-row w-full py-1 ${routePath == "settings"
                ? "text-yellow-300 border-l-4 border-yellow-300"
                : " hover:text-yellow-300"
                }`}
            >
              <div
                className={`w-10 h-10 mx-6 ${routePath == "settings"
                  ? "menu-active-container rounded-lg"
                  : null
                  }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="mx-auto my-2 w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
                  />
                </svg>
              </div>
              <h2 className=" font-medium my-auto">Settings</h2>
            </button>
          </Link>
        ) : null}
        <hr className="mx-auto bg-gray-800 w-[193px] border-0 h-px dark:bg-gray-700 mb-2 hover:bg-blue-500"></hr>
      </div>

      {timeZoneStatus
        ? (
          <div className="bg-white w-full h-full min-h-screen z-50 fixed top-0 left-0 text-center">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center flex flex-col">
              <div className=" text-[#F6932D] items-center mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                </svg>
              </div>
              <div className="text-center mt-2 text-base">
                Your timezone details are empty ! <br />
                We will redirect you to your profile in a moment !! Please update your timezone !
              </div>

              <span className="text-[#F6932D] items-center mt-5 text-base">{timerCount}</span>
            </div>
          </div>
        )
        : null
      }
    </>
  );
}

export default SideBar;
